import React, {useState, useContext, useEffect } from 'react';
import { Card, Row, Col, Button, Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';

import PsContext from '../../../context';
import { PSListItem } from '../../../comp';
import EditSocial from './editSocial';

const SocialInfo = (props) =>{
	
	const context = useContext(PsContext);
	const [adminCompany, setAdminCompany] = useState(false);
	const [edit, setEdit] = useState(false);

	return(
		<>
			<Modal show={adminCompany} onHide={()=> setAdminCompany(false)}>
				<Modal.Header closeButton>
				  <Modal.Title>Edit Social</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<EditSocial afterfinish= {()=> setAdminCompany(false)}/>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal>
			
			
			
			<Card className="no-shadow" >
				<Card.Body>
					<Row >
						<Col>
							<h5>Social</h5>
						</Col>
						<Col className="d-flex justify-content-end" >
						
							<Button size="sm" variant="outline-primary" onClick={()=> setAdminCompany(true)}>
								<i className="fas fa-edit me-1" ></i> Edit 
							</Button>
						
						</Col>
					</Row>
					<hr />
					<PSListItem title="Instagram" subTitle={context.adminCompany.instagram} boldSubTitle />
					<PSListItem title="Facebook" subTitle={context.adminCompany.facebook} boldSubTitle />
					<PSListItem title="Email" subTitle={context.adminCompany.email} boldSubTitle /> 
				</Card.Body>
			</Card>
		</>
	);
};

export default SocialInfo;